import dayjs, { Dayjs } from "utils/dayjs"
import { Guid } from "@/types"
import AmountWithCurrency, { IAmountWithCurrencyDto } from "./AmountWithCurrency"

export interface IGetEvaluationCommonInfoDto {
    lmid: string
    assetId: Guid
    articleDescription: string
    isAssetLabeled: boolean
    articleId: Guid
    articleNo: string
    constructionYear: number
    acquisitionDate?: string
    ifrsPeriod: number
    localPeriod: number
    totalAdditionsIfrs: IAmountWithCurrencyDto
    totalAdditionsLocal: IAmountWithCurrencyDto
    residualValueIfrs: IAmountWithCurrencyDto
    residualValueLocal: IAmountWithCurrencyDto
    disposalDate?: string
    disposalBookValueIFRS?: IAmountWithCurrencyDto
    disposalBookValueLocal?: IAmountWithCurrencyDto
    bookingPeriod: string
    hasNotConsideredInvoices: boolean
    isIfrsPeriodEditable: boolean
    isIfrsPeriodManuallySet: boolean
    ifrsPeriodChangedBy?: string
    ifrsPeriodChangedOn?: string
    ifrsPeriodComment?: string
    maxIfrsPeriod?: number
    minIfrsPeriod?: number
}

export default class EvaluationCommonInfo {
    articleDescription: string
    lmid: string
    assetId: Guid
    isAssetLabeled: boolean
    articleId: Guid
    articleNo: string
    constructionYear: number
    acquisitionDate?: Dayjs
    ifrsPeriod: number
    localPeriod: number
    totalAdditionsIfrs: AmountWithCurrency
    totalAdditionsLocal: AmountWithCurrency
    residualValueIfrs: AmountWithCurrency
    residualValueLocal: AmountWithCurrency
    disposalDate?: Dayjs
    disposalBookValueIFRS?: AmountWithCurrency
    disposalBookValueLocal?: AmountWithCurrency
    bookingPeriod: Dayjs
    hasNotConsideredInvoices: boolean
    isIfrsPeriodEditable: boolean
    isIfrsPeriodManuallySet: boolean
    ifrsPeriodChangedBy?: string
    ifrsPeriodChangedOn?: Dayjs
    ifrsPeriodComment?: string
    maxIfrsPeriod?: number
    minIfrsPeriod?: number

    constructor(dto: IGetEvaluationCommonInfoDto) {
        this.articleDescription = dto.articleDescription
        this.lmid = dto.lmid
        this.assetId = dto.assetId
        this.isAssetLabeled = dto.isAssetLabeled
        this.articleId = dto.articleId
        this.articleNo = dto.articleNo
        this.constructionYear = dto.constructionYear
        this.acquisitionDate = dto.acquisitionDate ? dayjs(dto.acquisitionDate, "YYYY-MM-DD") : undefined // take only date ignoring the time
        this.ifrsPeriod = dto.ifrsPeriod
        this.localPeriod = dto.localPeriod
        this.totalAdditionsIfrs = new AmountWithCurrency(dto.totalAdditionsIfrs)
        this.totalAdditionsLocal = new AmountWithCurrency(dto.totalAdditionsLocal)
        this.residualValueIfrs = new AmountWithCurrency(dto.residualValueIfrs)
        this.residualValueLocal = new AmountWithCurrency(dto.residualValueLocal)
        this.disposalDate = dto.disposalDate ? dayjs(dto.disposalDate, "YYYY-MM-DD") : undefined // take only date ignoring the time
        this.disposalBookValueIFRS = dto.disposalBookValueIFRS ? new AmountWithCurrency(dto.disposalBookValueIFRS) : undefined
        this.disposalBookValueLocal = dto.disposalBookValueLocal ? new AmountWithCurrency(dto.disposalBookValueLocal) : undefined
        this.bookingPeriod = dayjs(dto.bookingPeriod, "YYYY-MM")
        this.hasNotConsideredInvoices = dto.hasNotConsideredInvoices
        this.isIfrsPeriodEditable = dto.isIfrsPeriodEditable ?? false
        this.isIfrsPeriodManuallySet = dto.isIfrsPeriodManuallySet ?? false
        this.ifrsPeriodChangedBy = dto.ifrsPeriodChangedBy
        this.ifrsPeriodChangedOn = dto.ifrsPeriodChangedOn ? dayjs(dto.ifrsPeriodChangedOn) : undefined
        this.ifrsPeriodComment = dto.ifrsPeriodComment
        this.maxIfrsPeriod = dto.maxIfrsPeriod
        this.minIfrsPeriod = dto.minIfrsPeriod
    }
}
